var _defs, _path, _path2, _path3, _rect, _rect2, _polygon, _polygon2, _polygon3, _polygon4, _polygon5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefender(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a7e5c284-13cc-4ac5-b842-ecfb3e7bbb73",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a3df7d19-3d54-4d86-b7b8-c8d5b9b1be6b",
    x1: 9,
    y1: 16.21,
    x2: 9,
    y2: 0.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1b93eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#2095eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#2e9ced"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#45a7ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#64b6f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6bb9f2"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-security-244") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,8.44c0,4.57-5.53,8.25-6.73,9a.43.43,0,0,1-.46,0C7.57,16.69,2,13,2,8.44V2.94a.44.44,0,0,1,.43-.44C6.77,2.39,5.78.5,9,.5s2.23,1.89,6.53,2a.44.44,0,0,1,.43.44Z",
    fill: "#1b93eb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.38,8.48c0,4.2-5.07,7.57-6.17,8.25a.4.4,0,0,1-.42,0c-1.1-.68-6.17-4.05-6.17-8.25v-5A.41.41,0,0,1,3,3c3.94-.11,3-1.83,6-1.83S11.05,2.93,15,3a.41.41,0,0,1,.39.4Z",
    fill: "url(#a3df7d19-3d54-4d86-b7b8-c8d5b9b1be6b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.94,12.72c-1.07-.14-1-.83-1-1.94h-2c0,1.11,0,1.8-1,1.94a.56.56,0,0,0-.51.49h5.1A.56.56,0,0,0,10.94,12.72Z",
    fill: "#1f56a3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.3,
    y: 4.31,
    width: 9.18,
    height: 6.5,
    rx: 0.31,
    fill: "#1490df"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.83,
    y: 4.82,
    width: 8.11,
    height: 5.39,
    rx: 0.16,
    fill: "#fff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "10.53 6.57 10.54 8.46 8.88 9.42 8.89 7.52 10.53 6.57",
    fill: "#0078d4"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "10.53 6.56 8.89 7.52 7.24 6.56 8.88 5.61 10.53 6.56",
    fill: "#83b9f9"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "8.89 7.52 8.88 9.42 7.23 8.46 7.23 6.56 8.89 7.52",
    fill: "#5ea0ef"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "8.89 7.51 8.88 7.52 8.88 9.42 8.88 9.42 10.53 8.46 8.89 7.51",
    fill: "#5ea0ef",
    opacity: 0.2
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "8.87 7.54 8.88 7.54 8.88 9.44 8.88 9.44 7.23 8.49 8.87 7.54",
    fill: "#83b9f9",
    opacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefender);
export default __webpack_public_path__ + "static/media/Defender.4a6c8ac72fbb2a47f8afe555a7488a4d.svg";
export { ForwardRef as ReactComponent };